import { render } from "./PhoneVerification.vue?vue&type=template&id=38c42075&scoped=true&ts=true"
import script from "./PhoneVerification.vue?vue&type=script&lang=ts"
export * from "./PhoneVerification.vue?vue&type=script&lang=ts"

import "./PhoneVerification.vue?vue&type=style&index=0&id=38c42075&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c42075"]])